import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  panel: {
    background: theme.palette.background.modalBg,
    color: theme.palette.text.primary,
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",
    borderRadius: 16,
    padding: "24px 24px",
    border: "1px solid",
    borderColor: "black",
    transition: "background 0.3s, color 0.3s",
    height: "min-content",
    minWidth: "320px",
    width: "min-content",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "8px",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  panelHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    width: "100%",
  },

  panelBody: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  panelTitle: {
    fontFamily: "Philosopher",
    fontWeight: 900,
    color: "white",
    fontSize: 18,
    width: "100%",
    textAlign: "center",
  },

  payTableHeader: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr",
    width: "100%",
    borderBottom: "1px solid #ffffff10",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF60",
      fontsize: 14,
    },
  },

  payTableList: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  payTableItem: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr",
    width: "100%",
    borderBottom: "1px solid #ffffff10",
    padding: "4px 0 ",
    transitionDuration: "300ms",
    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF",
      fontsize: 14,
    },
  },

  paySymbols: {
    display: "flex",
    gap: "8px",
    alignItems: "center",

    "& img": {
      width: 20,
      height: 20,
    },
  },

  highlight: {
    background: "rgba(255, 255, 255, 0.5)",
  },
}));

export default styles;
